<template>
    <div v-if="projectId" class="position-relative">
        <div v-for="item in links" :key="item.link" class="block-item-sidebar">

            <BLink class="button-sidebar"
                   v-ripple
                   :class="{'active': isActive(item.paths), 'button-sidebar-min': isSmallDesign}"
                   @click="handleClick($event, item.paths)"
                   :href="item.link">
                <i class="mi-1-3x top-0" :class="item.icon"></i>
                <span :class="{'ml-1': !isSmallDesign}">{{item.title}}</span>
                <i v-if="showIconWidgetContentItems(item?.showWidgetContentItems)"
                   @click.prevent.stop="toggleWidget"
                   :class="{'rotate': showWidget}"
                   class="mi-expand-more transition-all-0-5 top-0 ml-auto"
                   v-ripple>
                </i>
            </BLink>

            <transition name="fade">
                <WidgetContentItems
                    v-if="showIconWidgetContentItems(item?.showWidgetContentItems)"
                    :show-widget="showWidget"
                    :project-id="projectId"
                    :article-id="articleId"
                    :style="widgetStyles"/>
            </transition>

        </div>

    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import sidebarMixin from "@/mixins/sidebar/mixin";
import widgetPosition from "@/mixins/sidebar/widget-position";
import WidgetContentItems from "@/components/general/widgets/WidgetContentItems";

export default {
    name: 'LinkContentSidebar',
    computed: {
        ...mapGetters(['isSmallDesign', 'currentUserCan', 'isExpandedSidebar']),
        ...mapState({
            projectId: state => state.sidebar.projectId,
            path: state => state.sidebar.path,
        }),
        isEditArticlePage: vm => vm.path.includes(`${vm.projectId}/edit/`),
        showIconWidgetContentItems: vm => itemAvailable => itemAvailable && vm.isExpandedSidebar && vm.isEditArticlePage,
        links() {
            let links = [
                {'title': 'Dashboard', 'icon': 'mi-web', 'link': `/project/${this.projectId}`, paths: [`project/${this.projectId}`]},
                {
                    'title': 'Content',
                    'icon': 'mi-format-list-bulleted',
                    'link': `/project/${this.projectId}/content-items`,
                    paths: [`project/${this.projectId}/content-items`, `project/${this.projectId}/content-items-old`],
                    showWidgetContentItems: true
                },
            ];

            if (this.currentUserCan('view_topics') || this.currentUserCan('manage_topics')) {
                links.push({'title': 'Briefs', 'icon': 'mi-playlist-add-check', 'link': `/project/${this.projectId}/topics`, paths: [`project/${this.projectId}/topics`]});
            }
            if (this.currentUserCan('manage_files')) {
                links.push({'title': 'Files', 'icon': 'mi-attach-file', 'link': `/project/${this.projectId}/files`, paths: [`project/${this.projectId}/files`]});
            }

            return links;
        },
        articleId() {
            const match = this.path.match(/\/edit\/(\d+)/);
            const articleId = match ? parseInt(match[1], 10) : 0;

            return Number.isInteger(articleId) && articleId > 0 ? Number(articleId) : 0;
        }
    },
    components: {
        WidgetContentItems
    },
    mixins: [sidebarMixin, widgetPosition],
}
</script>
